import { LAZY_TURBO_FRAME_IDS } from "./lazy_frame_ids"

document.addEventListener("turbo:frame-missing", (event) => {
  const frame = event.target
  if (!(frame instanceof Element)) return
  if (frame.id === "conversation_frame") return

  if (!LAZY_TURBO_FRAME_IDS.includes(frame.id)) return

  event.preventDefault()
})
